import { jsx as _jsx } from "react/jsx-runtime";
import { EditAndCreateBase } from "$components/List/EditAndCreateBase";
const ListEdit = (props) => {
    return _jsx(EditAndCreateBase, { variantProps: props, variant: "edit" });
};
export { ListEdit };
